import * as Images from "./Images"
import * as Addons from "./Addons"
import moment from "moment"
import { getTotalHTFromAL } from "./Utils"

export const width = 210
export const height = 297
export const sizeBig = 13
export const sizeBig2 = 16
export const sizeBig3 = 32
export const sizeTitle = 11
export const sizeNormal = 9
export const sizeHigher = 12
export const tarifW = 30
export const tarifH = 10
export const mx = 15

export function drawUnderlinedText(doc, str, x, y, w, h) {}

export function drawSquare(doc, x0, x1, y0, y1) {
	doc.line(x0, y0, x1, y0)
	doc.line(x0, y1, x1, y1)
	doc.line(x0, y0, x0, y1)
	doc.line(x1, y0, x1, y1)
}

export function textNormal(doc, str, x, y, align = "left", color = [0, 0, 0]) {
	doc.setTextColor(color[0], color[1], color[2])
	doc.setFontSize(sizeNormal)
	doc.setFont(undefined, "normal")
	doc.text(x, y, str, align)
}

export function textItalic(doc, str, x, y, align = "left", color = [0, 0, 0]) {
	doc.setTextColor(color[0], color[1], color[2])
	doc.setFontSize(sizeNormal)
	doc.setFont(undefined, "italic")
	doc.text(x, y, str, align)
}

export function textNormalBold(doc, str, x, y, align = "left") {
	doc.setFontSize(sizeNormal)
	doc.setFont(undefined, "bold")
	doc.text(x, y, str, align)
}

export function textNormalBoldHigher(doc, str, x, y, align = "left") {
	doc.setFontSize(sizeHigher)
	doc.setFont(undefined, "bold")
	doc.text(x, y, str, align)
}

export function textTitle(doc, str, x, y, align = "left") {
	doc.setFontSize(sizeTitle)
	doc.setFont(undefined, "bold")
	doc.text(x, y, str, align)
}

export function textBig(doc, str, x, y, align = "left") {
	doc.setFontSize(sizeBig)
	doc.setFont(undefined, "bold")
	doc.text(x, y, str, align)
}

export function textBig2(doc, str, x, y, align = "left") {
	doc.setFontSize(sizeBig2)
	doc.setFont(undefined, "bold")
	doc.text(x, y, str, align)
}

export function textBig3(doc, str, x, y, align = "left") {
	doc.setFontSize(sizeBig3)
	doc.setFont(undefined, "bold")
	doc.text(x, y, str, align)
}

export function watermarkCleFour(doc, isFour, hasKey) {
	let strKey = `${hasKey ? "Avec" : "Sans"} clé`
	let pageWidth = doc.internal.pageSize.getWidth()
	let pageHeight = doc.internal.pageSize.getHeight()
	let x0 = pageWidth / 2 + 20,
		y0 = pageHeight / 2
	let y1 = y0 + 50
	doc.saveGraphicsState()
	doc.setGState(new doc.GState({ opacity: 0.2 }))
	doc.setFontSize(70)
	if (isFour) {
		doc.text("Fourrière", x0, y0, {
			align: "center",
			baseline: "middle",
			angle: 45,
		})
		doc.text(strKey, x0, y1, {
			align: "center",
			baseline: "middle",
			angle: 45,
		})
	} else {
		doc.text(strKey, x0, y0, {
			align: "center",
			baseline: "middle",
			angle: 45,
		})
	}
	doc.restoreGraphicsState()
}

export function drawAtelier(
	doc,
	atelierInfo,
	transaction,
	mdps,
	isDevis,
	sousReserve = false,
) {
	let { atelier, atelierLignes } = atelierInfo
	let my = 80,
		spaceY = 5,
		spaceX = 20,
		spaceX2 = 12,
		col1 = width - mx - spaceX,
		col2 = col1 - spaceX2,
		col3 = col2 - spaceX2,
		col4 = col3 - spaceX2,
		col5 = col4 - spaceX2
	let rabaisFlatC = (col2 - col3) / 2 + col3,
		rabaisC = (col1 - col2) / 2 + col2,
		totalC = (width - mx - col1) / 2 + col1
	let prixUC = (col3 - col4) / 2 + col4,
		quantC = (col4 - col5) / 2 + col5
	let hTableau = 10,
		bTableau = 80,
		maxChar = 80,
		prevType = -1
	let mainOeuvres = atelierLignes.filter((aL) => aL.type === 1)
	let fournitures = atelierLignes.filter((aL) => aL.type === 0)
	let autres = atelierLignes.filter((aL) => aL.type === 2)
	let fullList = [...mainOeuvres, ...fournitures, ...autres]
	let clientList = fullList.filter((aL) => aL.payePar === 1)
	// eslint-disable-next-line no-unused-vars
	let moHeures = 0,
		moHT = 0,
		fouHT = 0,
		autHT = 0
	mainOeuvres.forEach((mo) => {
		moHeures += mo.quantite
		moHT += getTotalHTFromAL(mo, atelier.tva)
	})
	moHT = Addons.round100(moHT)
	fournitures.forEach((fou) => {
		fouHT += getTotalHTFromAL(fou, atelier.tva)
	})
	fouHT = Addons.round100(fouHT)
	autres.forEach((aut) => {
		autHT += getTotalHTFromAL(aut, atelier.tva)
	})
	autHT = Addons.round100(autHT)
	let mxT = mx + 2
	// Entête
	bTableau = my
	textNormalBold(doc, "Description", (col3 - mx) / 2 + mx, my + 3.2, "center")
	textNormalBold(doc, "Quant", quantC, my + 3.2, "center")
	textNormalBold(doc, "Prix U", prixUC, my + 3.2, "center")
	textNormalBold(doc, "Rab %", rabaisC, my + 3.2, "center")
	textNormalBold(doc, "Rab HT", rabaisFlatC, my + 3.2, "center")
	textNormalBold(doc, "Total CHF", totalC, my + 3.2, "center")
	my += 10
	fullList.forEach((item) => {
		if (my >= 267) {
			// Tableau lines
			doc.setLineWidth(0.1)
			//////// extérieur
			doc.line(mx, bTableau, width - mx, bTableau)
			doc.line(mx, bTableau + hTableau, width - mx, bTableau + hTableau)
			doc.line(mx, bTableau, mx, bTableau + hTableau)
			doc.line(width - mx, bTableau, width - mx, bTableau + hTableau)
			//////// entête
			doc.setLineWidth(0.5)
			doc.line(mx, bTableau + 5, width - mx, bTableau + 5)
			doc.setLineWidth(0.1)
			//////// intérieur
			doc.line(col5, bTableau, col5, hTableau + bTableau)
			doc.line(col4, bTableau, col4, hTableau + bTableau)
			doc.line(col3, bTableau, col3, hTableau + bTableau)
			doc.line(col2, bTableau, col2, hTableau + bTableau)
			doc.line(col1, bTableau, col1, hTableau + bTableau)

			// Add Page
			doc.addPage()
			my = 10
			hTableau = 10
			bTableau = 10
			textNormalBold(
				doc,
				"Description",
				(col3 - mx) / 2 + mx,
				my + 3.2,
				"center",
			)
			textNormalBold(doc, "Quant", quantC, my + 3.2, "center")
			textNormalBold(doc, "Prix U", prixUC, my + 3.2, "center")
			textNormalBold(doc, "Rab %", rabaisC, my + 3.2, "center")
			textNormalBold(doc, "Rab HT", rabaisFlatC, my + 3.2, "center")
			textNormalBold(doc, "Total CHF", totalC, my + 3.2, "center")
			my += 10
		}
		if (prevType === -1 && item.type === 1) {
			textNormalBold(doc, "Main d'oeuvre :", mxT + 5, my)
			doc.line(mxT + 5, my + 1.2, mxT + 26.5, my + 1.2)
			my += spaceY
			hTableau += spaceY
			prevType = 1
		}
		if ([-1, 1].includes(prevType) && item.type === 0) {
			textNormalBold(doc, "Fournitures :", mxT + 5, my)
			doc.line(mxT + 5, my + 1.2, mxT + 23, my + 1.2)
			my += spaceY
			hTableau += spaceY
			prevType = 0
		}
		if ([-1, 0, 1].includes(prevType) && item.type === 2) {
			textNormalBold(doc, "Autres :", mxT + 5, my)
			doc.line(mxT + 5, my + 1.2, mxT + 16, my + 1.2)
			my += spaceY
			hTableau += spaceY
			prevType = 2
		}
		textNormal(
			doc,
			Addons.getStrForTable(item.label, maxChar),
			mxT,
			my,
			"left",
			atelier.splitPaye && item.payePar === 1 ? [150, 0, 0] : [0, 0, 0],
		)
		if (item.quantite > 0) {
			textNormal(
				doc,
				item.quantite.toString(),
				quantC,
				my,
				"center",
				atelier.splitPaye && item.payePar === 1
					? [150, 0, 0]
					: [0, 0, 0],
			)
			let prixVente = item.prixVente
			if (!item.isHT)
				prixVente = Addons.round100(
					Addons.TTCtoHT(prixVente, atelier.tva),
				)
			textNormal(
				doc,
				Addons.round100(prixVente).toString(),
				prixUC,
				my,
				"center",
				atelier.splitPaye && item.payePar === 1
					? [150, 0, 0]
					: [0, 0, 0],
			)
			textNormal(
				doc,
				Addons.round100(getTotalHTFromAL(item, atelier.tva)).toString(),
				totalC,
				my,
				"center",
				atelier.splitPaye && item.payePar === 1
					? [150, 0, 0]
					: [0, 0, 0],
			)
			if (item.rabais !== 0) {
				textNormal(
					doc,
					Addons.round100(item.rabais).toString(),
					item.rabaisIsFlat ? rabaisFlatC : rabaisC,
					my,
					"center",
					atelier.splitPaye && item.payePar === 1
						? [150, 0, 0]
						: [0, 0, 0],
				)
			}
		}
		my += spaceY
		hTableau += spaceY
	})
	my -= 1.6
	hTableau -= 1.6
	let deltaFranchise = 0
	let franchise = parseFloat(atelier.franchise),
		rabaisFranchise = parseFloat(atelier.rabaisFranchise)
	// Tableau lines
	doc.setLineWidth(0.1)
	//////// extérieur
	doc.line(mx, bTableau, width - mx, bTableau)
	doc.line(mx, bTableau + hTableau, width - mx, bTableau + hTableau)
	doc.line(mx, bTableau, mx, bTableau + hTableau)
	doc.line(width - mx, bTableau, width - mx, bTableau + hTableau)
	//////// entête
	doc.setLineWidth(0.5)
	doc.line(mx, bTableau + 5, width - mx, bTableau + 5)
	doc.setLineWidth(0.1)
	//////// intérieur
	doc.line(col5, bTableau, col5, hTableau + bTableau - deltaFranchise)
	doc.line(col4, bTableau, col4, hTableau + bTableau - deltaFranchise)
	doc.line(col3, bTableau, col3, hTableau + bTableau - deltaFranchise)
	doc.line(col2, bTableau, col2, hTableau + bTableau - deltaFranchise)
	doc.line(col1, bTableau, col1, hTableau + bTableau)
	let hMinNeeded = 38.4,
		hFooter = 38.4,
		totTrans = parseFloat(transaction.total),
		total = parseFloat(atelier.total),
		mdp,
		rabais = parseFloat(atelier.rabais)
	if (!isDevis) mdp = Addons.getMdpTot(mdps, transaction.moyenPaie, totTrans)
	else mdp = 0
	let totClient = 0
	clientList.forEach((aL) => {
		if (aL.isHT)
			totClient +=
				aL.quantite *
				Addons.round100(Addons.HTtoTTC(aL.prixVente, atelier.tva))
		else totClient += aL.quantite * aL.prixVente
	})
	let aPayer = atelier.splitPaye
		? franchise - rabaisFranchise + totClient - rabais
		: total - rabais
	//// checkspace
	if (typeof rabais === "number" && !Number.isNaN(rabais) && rabais !== 0) {
		hMinNeeded += 20
		hFooter += 20
	}
	if (franchise !== 0 && atelier.splitPaye) {
		hMinNeeded += 10
		hFooter += 10
		if (rabaisFranchise !== 0) {
			hMinNeeded += 10
			hFooter += 10
		}
	}
	if (atelier.splitPaye && rabais !== 0) {
		hMinNeeded += 5
		hFooter += 5
	}
	if (atelier.splitPaye && clientList.length > 0) {
		hMinNeeded += 10
		hFooter += 10
	}
	if (!Number.isNaN(totTrans) && aPayer !== totTrans) {
		hMinNeeded += 10
		hFooter += 10
	}
	if (fouHT > 0) {
		hMinNeeded += 5
		hFooter += 5
	}
	if (autHT > 0) {
		hMinNeeded += 5
		hFooter += 5
	}
	if (moHT > 0) {
		hMinNeeded += 5
		hFooter += 5
	}
	if (my >= height - hMinNeeded) {
		doc.addPage()
		my = 10
	}
	// footer
	let myB = my + spaceY
	//////// lines
	doc.setLineWidth(0.1)
	doc.line(mx, my, width - mx, my)
	doc.line(mx, my + hFooter, width - mx, my + hFooter)
	doc.line(mx, my, mx, my + hFooter)
	doc.line(width - mx, my, width - mx, my + hFooter)
	doc.line(col1, my, col1, my + hFooter)
	//////// Total HT
	if (moHT > 0) {
		textNormal(doc, "Main d'oeuvre HT", mxT, myB, "left")
		textNormal(doc, `${moHT}`, totalC, myB, "center")
		myB += 5
	}
	if (fouHT > 0) {
		textNormal(doc, "Fournitures HT", mxT, myB, "left")
		textNormal(doc, `${fouHT}`, totalC, myB, "center")
		myB += 5
	}
	if (autHT > 0) {
		textNormal(doc, "Autres HT", mxT, myB, "left")
		textNormal(doc, `${autHT}`, totalC, myB, "center")
		myB += 5
	}
	let sTotHT = Addons.round100(Addons.TTCtoHT(total, atelier.tva))
	let rabaisHT =
		rabais === 0 ? 0 : Addons.round100(Addons.TTCtoHT(rabais, atelier.tva))
	let totHT = sTotHT - rabaisHT
	textNormal(doc, rabaisHT === 0 ? "Total HT" : "Sous-total HT", mxT, myB)
	textNormal(
		doc,
		sTotHT.toString(),
		(width - mx - col1) / 2 + col1,
		myB,
		"center",
	)
	myB += 5
	if (rabaisHT !== 0) {
		textNormal(doc, "Rabais HT", mxT, myB)
		textNormal(
			doc,
			"-" + rabaisHT.toString(),
			(width - mx - col1) / 2 + col1,
			myB,
			"center",
		)
		myB += 5
		textNormal(doc, "Total HT", mxT, myB)
		textNormal(
			doc,
			Addons.round100(totHT).toString(),
			(width - mx - col1) / 2 + col1,
			myB,
			"center",
		)
		myB += 5
	}
	myB += 5
	//////// tva
	textNormal(doc, `TVA ${atelier.tva}%`, mxT, myB)
	textNormal(
		doc,
		Addons.round100((totHT * atelier.tva) / 100).toString(),
		(width - mx - col1) / 2 + col1,
		myB,
		"center",
	)
	myB += 5
	//////// sous-total TTC
	if (
		mdp > 0 ||
		aPayer !== total ||
		(atelier.splitPaye &&
			(totClient > 0 || aPayer !== totTrans || franchise !== 0))
	) {
		let sTotTTC = total - rabais
		textNormal(doc, "Sous-total TTC", mxT, myB)
		textNormal(
			doc,
			Addons.round100(sTotTTC).toString(),
			(width - mx - col1) / 2 + col1,
			myB,
			"center",
		)
		myB += 10
	}
	//////// franchise
	if (franchise !== 0 && atelier.splitPaye) {
		textNormal(doc, "Franchise", mxT, myB)
		textNormal(
			doc,
			franchise.toString(),
			(width - mx - col1) / 2 + col1,
			myB,
			"center",
		)
		myB += 5
		if (rabaisFranchise !== 0) {
			textNormal(doc, "Rabais franchise", mxT, myB)
			textNormal(
				doc,
				"-" + rabaisFranchise.toString(),
				(width - mx - col1) / 2 + col1,
				myB,
				"center",
			)
			myB += 5
			textNormal(doc, "Total franchise", mxT, myB)
			textNormal(
				doc,
				(franchise - rabaisFranchise).toString(),
				(width - mx - col1) / 2 + col1,
				myB,
				"center",
			)
			myB += 5
		}
		myB += 5
	}
	//////// total ttc
	// textNormalBold(doc, 'Total TTC', mxT, myB)
	// textNormalBold(doc, Addons.round100(total - rabais).toString() + ' CHF', (width - mx - col1) / 2 + col1, myB, 'center')
	// myB += 5
	//////// supp client
	if (atelier.splitPaye && totClient > 0) {
		textNormal(doc, "Supplément client TTC", mxT, myB, "left", [150, 0, 0])
		textNormal(
			doc,
			Addons.round100(totClient).toString(),
			(width - mx - col1) / 2 + col1,
			myB,
			"center",
			[150, 0, 0],
		)
		myB += 5
		if (rabais !== 0) {
			textNormal(doc, "Rabais client TTC", mxT, myB, "left", [150, 0, 0])
			textNormal(
				doc,
				Addons.round100(-rabais).toString(),
				(width - mx - col1) / 2 + col1,
				myB,
				"center",
				[150, 0, 0],
			)
			myB += 5
		}
	}
	////////// A payer
	textNormal(doc, "A payer", mxT, myB)
	textNormal(
		doc,
		Addons.round100(aPayer).toString(),
		(width - mx - col1) / 2 + col1,
		myB,
		"center",
	)
	myB += 5
	if (
		!Number.isNaN(totTrans) &&
		Addons.round100(aPayer) !== Addons.round100(totTrans)
	) {
		textNormal(doc, "Paiement partiel", mxT, myB)
		textNormal(
			doc,
			Addons.round100(totTrans).toString(),
			(width - mx - col1) / 2 + col1,
			myB,
			"center",
		)
		myB += 5
	}
	//////// moyen paiement
	textNormal(doc, "Supplément moyen de paiement", mxT, myB)
	textNormal(
		doc,
		mdp.toString(),
		(width - mx - col1) / 2 + col1,
		myB,
		"center",
	)
	myB += 5
	textNormalBold(doc, "Total à payer", mxT, myB)
	textNormalBold(
		doc,
		Number.isNaN(totTrans)
			? Addons.round100(aPayer + mdp).toString()
			: Addons.round100(totTrans + mdp).toString() + " CHF",
		(width - mx - col1) / 2 + col1,
		myB,
		"center",
	)
	myB += 5
	if (!Number.isNaN(totTrans) && aPayer !== totTrans && !isDevis) {
		textNormal(doc, "Reste à payer", mxT, myB)
		textNormal(
			doc,
			Addons.round100(aPayer - totTrans).toString(),
			(width - mx - col1) / 2 + col1,
			myB,
			"center",
		)
		myB += 5
	}

	my = myB
	my += 15

	if (isDevis) {
		textItalic(
			doc,
			"Le prix du devis peut varier de + ou - 10%",
			width / 2,
			my,
			"center",
		)
		if (sousReserve) {
			my += 5
			textItalic(
				doc,
				"Sous réserve de démontage",
				width / 2,
				my,
				"center",
			)
		}
	}
	if (atelierInfo.atelierCommentaires.filter((a) => a.print).length > 0) {
		// Commentaires
		let hCom =
			atelierInfo.atelierCommentaires.filter((a) => a.print).length * 5
		if (hCom !== 0) hCom += 10
		if (my + hCom >= 257 && hCom !== 0) {
			doc.addPage()
			my = 10
		}
		if (atelierInfo.atelierCommentaires.filter((a) => a.print).length > 0) {
			my += 5
			textNormalBold(doc, "Commentaires", mx, my, "left")
			my += 5
			atelierInfo.atelierCommentaires
				.filter((a) => a.print)
				.forEach((com) => {
					let color = [0, 0, 0]
					if (com.marked) color[0] = 200
					textNormal(doc, com.texte, mx, my, "left", color)
					my += 5
				})
			doc.setTextColor(0, 0, 0)
		}
		// Footer
		//////// Prochain service
		doc.setDrawColor(150, 0, 0)
		doc.line(mx, height - 25, width / 2 - 20, height - 25)
		doc.line(
			mx,
			height - 25 + Images.warning.height,
			width / 2 - 20,
			height - 25 + Images.warning.height,
		)
		doc.line(mx, height - 25, mx, height - 25 + Images.warning.height)
		doc.line(
			width / 2 - 20,
			height - 25,
			width / 2 - 20,
			height - 25 + Images.warning.height,
		)
		doc.setDrawColor(0, 0, 0)
		textNormalBold(
			doc,
			"Prochain service dans [kms]:",
			width / 4 + 5,
			height - 18,
			"right",
		)
		textNormalBold(doc, "Ou le:", width / 4 + 5, height - 13, "right")

		//////// Image
		doc.addImage(
			Images.warning.img,
			"JPG",
			width / 2 - Images.warning.width / 2,
			height - 25,
			Images.warning.width,
			Images.warning.height,
		)

		//////// Remerciments
		textNormalBold(
			doc,
			"Nous vous remercions de votre confiance.",
			(width * 3) / 4,
			height - 18,
			"center",
		)
		textNormalBold(
			doc,
			"Avec nos meilleures salutations.",
			(width * 3) / 4,
			height - 13,
			"center",
		)
	}
}

export function drawDep(doc, dep = {}, transaction = {}, mdps, emps, input) {
	let my = 95,
		spaceY = 10,
		spaceX = 30,
		l0 = input.row0,
		l1 = input.row1,
		isPartiel = parseFloat(transaction.total) !== parseFloat(dep.totalFinal)
	// date d'intervention
	textNormalBold(doc, "Date d'intervention", mx, my)
	textNormal(doc, `${dep.date}   à   ${dep.heure}`, mx + spaceX, my)
	textNormalBold(doc, "Tarifs CHF", width - mx - tarifW / 2, my, "center")
	my += spaceY
	// intervention
	textNormalBold(doc, "Intervention", mx, my)
	drawRect(doc, mx + spaceX, my - 2.5, 3, l0 === 0)
	textNormal(doc, "Jour", mx + spaceX + 6, my)
	drawRect(doc, mx + spaceX * 2, my - 2.5, 3, l0 === 1)
	textNormal(doc, "Nuit", mx + spaceX * 2 + 6, my)
	drawRect(doc, mx + spaceX * 3, my - 2.5, 3, l0 === 2)
	textNormal(doc, "Week-end", mx + spaceX * 3 + 6, my)
	drawRect(doc, mx + spaceX * 4, my - 2.5, 3, l0 === 3)
	textNormal(doc, "Jour férié", mx + spaceX * 4 + 6, my)
	my += spaceY
	// lieu d'intervention
	textNormalBold(doc, "Lieu d'intervention", mx, my)
	textNormal(doc, dep.lieu, mx + spaceX, my)
	my += spaceY
	// Infos sup
	if (dep.cleSupp !== 0 || dep.carteGrise || dep.avecPlaques) {
		textNormalBold(doc, "Rendu avec", mx, my)
		let arr = [],
			str = ""
		if (dep.cleSupp !== 0) arr.push(`${dep.cleSupp} clé(s) supp.`)
		if (dep.carteGrise) arr.push("la carte grise")
		if (dep.avecPlaques) arr.push("les plaques")
		arr.forEach((value, i) => {
			if (i === 0) str = value[0].toUpperCase() + value.substring(1)
			else if (i > 0 && i < arr.length - 1) str += ", " + value
			else str += " et " + value
		})
		textNormal(doc, str, mx + spaceX, my)
		my += spaceY
	}
	// dépannage
	textNormalBold(doc, "Dépannage", mx, my)
	drawRect(doc, mx + spaceX, my - 2.5, 3, l1 === 0)
	textNormal(doc, "Accident", mx + spaceX + 6, my)
	drawRect(doc, mx + spaceX * 2, my - 2.5, 3, l1 === 1)
	textNormal(doc, "Panne", mx + spaceX * 2 + 6, my)
	drawRect(doc, mx + spaceX * 3, my - 2.5, 3, l1 === 2)
	textNormal(doc, "Déplacement", mx + spaceX * 3 + 6, my)
	drawTarif(doc, width - mx - tarifW, my, isPartiel ? "*" : dep.baseTot)
	my += spaceY
	// gardiennage
	textNormalBold(doc, "Gardiennage", mx, my)
	textNormal(doc, dep.gardQ.toString(), mx + spaceX, my)
	textNormal(doc, "jour(s)", mx + spaceX + 6, my)
	if (!isPartiel) {
		textNormal(doc, dep.gardT.toString(), mx + spaceX * 2, my)
		textNormal(doc, "par jour", mx + spaceX * 2 + 6, my)
	}
	drawRect(doc, mx + spaceX * 3, my - 2.5, 3)
	textNormal(doc, "Forfait", mx + spaceX * 3 + 6, my)
	drawTarif(doc, width - mx - tarifW, my, isPartiel ? "*" : dep.gardTot)
	my += spaceY
	if (dep.gardInfo !== "") {
		textNormal(doc, dep.gardInfo, mx + spaceX, my)
		my += spaceY
	}
	// restitution
	if (dep.restiDate !== "" && dep.restiHeure !== "") {
		textNormalBold(doc, "Restitution", mx, my)
		textNormal(doc, "le", mx + spaceX, my)
		textNormal(doc, dep.restiDate, mx + spaceX + 6, my)
		textNormal(doc, "à", mx + spaceX * 2, my)
		textNormal(doc, dep.restiHeure, mx + spaceX * 2 + 6, my)
		drawTarif(doc, width - mx - tarifW, my, isPartiel ? "*" : dep.restiTot)
		my += spaceY
		if (dep.restiInfo !== "") {
			textNormal(doc, dep.restiInfo, mx + spaceX, my)
			my += spaceY
		}
	}
	// heures sup
	textNormalBold(doc, "Heures supp.", mx, my)
	if (dep.hSupQ > 0 && dep.hSupT > 0) {
		textNormal(doc, dep.hSupQ.toString(), mx + spaceX, my)
		textNormal(doc, "heure(s)", mx + spaceX + 6, my)
		textNormal(doc, "à", mx + spaceX * 2, my)
		textNormal(
			doc,
			isPartiel ? "*" : dep.hSupT.toString(),
			mx + spaceX * 2 + 6,
			my,
		)
	}
	drawTarif(doc, width - mx - tarifW, my, isPartiel ? "*" : dep.hSupTot)
	my += spaceY
	if (dep.hSupInfo !== "") {
		textNormal(doc, dep.hSupInfo, mx + spaceX, my)
		my += spaceY
	}
	// livraison
	dep.livraisons.forEach((liv) => {
		if (liv.date !== "" && liv.heure !== "") {
			textNormalBold(doc, "Livraison", mx, my)
			textNormal(doc, "le", mx + spaceX, my)
			textNormal(doc, liv.date, mx + spaceX + 6, my)
			textNormal(doc, "à", mx + spaceX * 2, my)
			textNormal(doc, liv.heure, mx + spaceX * 2 + 6, my)
			drawTarif(doc, width - mx - tarifW, my, isPartiel ? "*" : liv.tot)
			my += spaceY
			if (liv.info !== "") {
				textNormal(doc, liv.info, mx + spaceX, my)
				my += spaceY
			}
		}
	})
	// autres
	if (dep.autres.length > 0) {
		textNormalBold(doc, "Autres", mx, my)
		for (let a of dep.autres) {
			textNormal(doc, a.info, mx + spaceX, my)
			drawTarif(doc, width - mx - tarifW, my, isPartiel ? "*" : a.total)
			my += spaceY
		}
	}
	//total HT
	my = 210
	//paiement partiel
	let totalHT, totalTVA, totalMdp, totalTTC
	totalHT = Addons.round100(Addons.TTCtoHT(transaction.total, dep.tva))
	totalTVA = Addons.round100(
		transaction.total -
			Addons.round100(Addons.TTCtoHT(transaction.total, dep.tva)),
	)
	totalMdp = Addons.getMdpTot(mdps, transaction.moyenPaie, transaction.total)
	totalTTC = transaction.total
	if (isPartiel) {
		let raisonStr =
			transaction.raison === "" ? "" : `   -   ${transaction.raison}`
		textNormalBold(doc, `Paiement partiel${raisonStr}`, mx, my)
		my += spaceY
	}
	textNormalBold(doc, "Total HT", mx, my)
	drawTarif(doc, width - mx - tarifW, my, totalHT.toString())
	my += spaceY
	//total TVA
	textNormalBold(doc, `TVA ${dep.tva}%`, mx, my)
	drawTarif(doc, width - mx - tarifW, my, totalTVA.toString())
	my += spaceY
	//soustotal TTC
	textNormalBold(doc, `Sous-total TTC`, mx, my)
	drawTarif(doc, width - mx - tarifW, my, totalTTC.toString())
	my += spaceY
	//total HT
	textNormalBold(doc, "Frais mode de paiement", mx, my)
	drawTarif(doc, width - mx - tarifW, my, totalMdp.toString())
	my += spaceY
	//total TTC
	textNormalBold(doc, "Total TTC", mx, my)
	drawTarif(
		doc,
		width - mx - tarifW,
		my,
		Addons.round100(parseFloat(totalTTC) + parseFloat(totalMdp)).toString(),
		true,
	)
	my += spaceY
	//payé le
	textNormalBold(doc, "Payé le", mx, my)
	doc.setLineWidth(0.1)
	doc.line(mx + spaceX, my, mx + spaceX + 40, my)
	my += spaceY
	//encaissé par
	textNormalBold(doc, "Encaissé par", mx, my)
	textNormal(
		doc,
		emps.find((emp) => emp.id === transaction.caissier).nom,
		mx + spaceX,
		my,
	)
	//////// Remerciments
	// textNormalBold(doc, 'Nous vous remercions de votre confiance.', width / 2, height - 20, 'center')
	// textNormalBold(doc, 'Avec nos meilleures salutations.', width / 2, height - 15, 'center')
}

export function drawTarif(doc, x, y, tarif, important = false) {
	doc.setFillColor(220, 220, 220)
	doc.rect(x, y - 5, tarifW, tarifH, "F")
	textNormal(
		doc,
		tarif.toString(),
		x + tarifW / 2,
		y + tarifH / 2 - 4,
		"center",
	)
	doc.setFillColor(0, 0, 0)
	if (important) {
		doc.setLineWidth(0.5)
		textNormalBold(
			doc,
			tarif.toString(),
			x + tarifW / 2,
			y + tarifH / 2 - 4,
			"center",
		)
	} else {
		doc.setLineWidth(0.1)
		textNormal(
			doc,
			tarif.toString(),
			x + tarifW / 2,
			y + tarifH / 2 - 4,
			"center",
		)
	}
	doc.line(x, y + (tarifH - 5), x + tarifW, y + (tarifH - 5))
}

export function drawRect(doc, x, y, size, crossed = false) {
	doc.line(x, y, x + size, y)
	doc.line(x, y + size, x + size, y + size)
	doc.line(x, y, x, y + size)
	doc.line(x + size, y, x + size, y + size)
	if (crossed) {
		doc.line(x, y, x + size, y + size)
		doc.line(x, y + size, x + size, y)
	}
}

export function drawTextRect(doc, texte, x, y, w, h, crossed = false) {
	doc.setFontSize(sizeNormal)
	doc.setFont(undefined, "bold")
	doc.text(x, y, texte, "left")
	doc.setFont(undefined, "normal")
	let size = h - 4,
		x0 = x + (w - size) / 2,
		y0 = y + 2,
		x1 = x0 + size,
		y1 = y0 + size
	doc.line(x0, y0, x1, y0)
	doc.line(x0, y1, x1, y1)
	doc.line(x0, y0, x0, y1)
	doc.line(x1, y0, x1, y1)
	if (crossed) {
		doc.line(x0, y0, x1, y1)
		doc.line(x0, y1, x1, y0)
	}
}

export function drawEntete(doc, tel = "022.771.11.71") {
	let mgY = 10
	doc.addImage(
		Images.logo.img,
		"PNG",
		width / 2 - Images.logo.width / 2,
		mgY,
		Images.logo.width,
		Images.logo.height,
	)
	textTitle(doc, "Garage SVP SA", mx, mgY + 8)
	textTitle(doc, "185, Route de Saint-Julien", mx, mgY + 15)
	textTitle(doc, "1228 Plan-les-Ouates", mx, mgY + 22)
	textTitle(doc, "www.Garage-SVP.ch", width - mx, mgY + 8, "right")
	textTitle(doc, `Tél. ${tel}`, width - mx, mgY + 15, "right")
	textTitle(doc, "N° TVA CHE-230.569.777", width - mx, mgY + 22, "right")
}

export function drawClient(
	doc,
	entete,
	line = true,
	partiel = false,
	title = "Facture",
) {
	let mgY = 20 + Images.logo.height,
		spaceX = 20,
		spaceY = 5,
		mgXR = width / 2 + Images.logo.width / 2
	//Recu
	textBig(doc, title, width / 2, mgY + spaceY * 1.5, "center")
	doc.line(width / 2 - spaceX, mgY + 2, width / 2 + spaceX, mgY + 2)
	doc.line(
		width / 2 - spaceX,
		mgY + 2 + spaceY * 1.5,
		width / 2 + spaceX,
		mgY + 2 + spaceY * 1.5,
	)
	doc.line(
		width / 2 - spaceX,
		mgY + 2,
		width / 2 - spaceX,
		mgY + 2 + spaceY * 1.5,
	)
	doc.line(
		width / 2 + spaceX,
		mgY + 2,
		width / 2 + spaceX,
		mgY + 2 + spaceY * 1.5,
	)

	mgY += 15

	//Entete left
	textNormalBold(doc, "Date", mx, mgY)
	textNormal(doc, entete.date, mx + spaceX, mgY)
	textNormalBold(doc, "Nom", mx, mgY + spaceY)
	textNormal(doc, `${entete.nom} ${entete.prenom}`, mx + spaceX, mgY + spaceY)
	textNormalBold(doc, "Adresse", mx, mgY + spaceY * 2)
	textNormal(doc, entete.adresse, mx + spaceX, mgY + spaceY * 2)
	textNormal(doc, entete.adresse2, mx + spaceX, mgY + spaceY * 3)
	if (entete.tel) {
		textNormalBold(doc, "Téléphone", mx, mgY + spaceY * 4)
		textNormal(doc, entete.tel, mx + spaceX, mgY + spaceY * 4)
	}

	//Entete mid
	// textNormalBold(doc, 'Date', width / 2 - spaceX, mgY)
	// textNormal(doc, entete.date, width / 2 + spaceX, mgY, 'right')
	if (partiel)
		textBig(doc, "Paiement partiel", width / 2, mgY + spaceY * 4, "center")

	//Entete right
	textNormalBold(doc, "Marque", mgXR, mgY)
	textNormal(doc, entete.marque, mgXR + spaceX, mgY)
	textNormalBold(doc, "Modèle", mgXR, mgY + spaceY)
	textNormal(doc, entete.modele, mgXR + spaceX, mgY + spaceY)
	textNormalBold(doc, "Plaques", mgXR, mgY + spaceY * 2)
	textNormal(doc, entete.plaques, mgXR + spaceX, mgY + spaceY * 2)
	if (entete.kms) {
		textNormalBold(doc, "Kms", mgXR, mgY + spaceY * 3)
		textNormal(doc, entete.kms.toString(), mgXR + spaceX, mgY + spaceY * 3)
	}

	if (line) doc.line(mx, mgY + spaceY * 5, width - mx, mgY + spaceY * 5)
}

export function drawClientPassage(doc, entete, line = true, partiel = false) {
	let mgY = 20 + Images.logo.height,
		spaceX = 20,
		spaceY = 5
	//Recu
	textBig(doc, "Reçu", width / 2, mgY + spaceY * 1.5, "center")
	doc.line(width / 2 - spaceX, mgY + 2, width / 2 + spaceX, mgY + 2)
	doc.line(
		width / 2 - spaceX,
		mgY + 2 + spaceY * 1.5,
		width / 2 + spaceX,
		mgY + 2 + spaceY * 1.5,
	)
	doc.line(
		width / 2 - spaceX,
		mgY + 2,
		width / 2 - spaceX,
		mgY + 2 + spaceY * 1.5,
	)
	doc.line(
		width / 2 + spaceX,
		mgY + 2,
		width / 2 + spaceX,
		mgY + 2 + spaceY * 1.5,
	)

	mgY += 15

	//Entete left
	textNormalBold(doc, "Nom", mx, mgY)
	textNormal(doc, `Client de passage`, mx + spaceX, mgY)
	// textNormalBold(doc, 'Adresse', mx, mgY + spaceY)
	// textNormal(doc, entete.adresse, mx + spaceX, mgY + spaceY)

	//Entete mid
	textNormalBold(doc, "Date", width / 2 - spaceX, mgY)
	textNormal(doc, entete.date, width / 2 + spaceX, mgY, "right")

	if (partiel)
		textBig(doc, "Paiement partiel", width / 2, mgY + spaceY * 4, "center")

	//Entete right
	if (line) doc.line(mx, mgY + spaceY * 5, width - mx, mgY + spaceY * 5)
}

export function drawClientLocation(doc, client, title) {
	let mgY = 15 + Images.logo.height,
		spaceX = 20,
		spaceY = 5,
		mxMid = width / 2 - spaceX - 2,
		spaceXtitle = 40
	//Recu
	textBig(doc, title, width / 2, mgY + spaceY * 1.5, "center")
	doc.line(width / 2 - spaceXtitle, mgY + 2, width / 2 + spaceXtitle, mgY + 2)
	doc.line(
		width / 2 - spaceXtitle,
		mgY + 2 + spaceY * 1.5,
		width / 2 + spaceXtitle,
		mgY + 2 + spaceY * 1.5,
	)
	doc.line(
		width / 2 - spaceXtitle,
		mgY + 2,
		width / 2 - spaceXtitle,
		mgY + 2 + spaceY * 1.5,
	)
	doc.line(
		width / 2 + spaceXtitle,
		mgY + 2,
		width / 2 + spaceXtitle,
		mgY + 2 + spaceY * 1.5,
	)

	mgY += 20

	//Entete left
	textTitle(doc, "Le locataire", mx, mgY)
	doc.line(mx, mgY + 1, mx + 20, mgY + 1)
	textNormalBold(doc, "Nom", mx, mgY + spaceY)
	textNormal(doc, `${client.nom} ${client.prenom}`, mx + spaceX, mgY + spaceY)
	textNormalBold(doc, "Adresse", mx, mgY + spaceY * 2)
	textNormal(doc, client.adresse, mx + spaceX, mgY + spaceY * 2)
	textNormal(doc, client.adresse2, mx + spaceX, mgY + spaceY * 3)
	textNormalBold(doc, "Téléphone", mx, mgY + spaceY * 4)
	textNormal(doc, client.tel, mx + spaceX, mgY + spaceY * 4)

	//Entete mid
	textNormalBold(doc, "Né(e) le", mxMid, mgY + spaceY)
	textNormal(doc, client.dateNaissance, mxMid + spaceX * 1.5, mgY + spaceY)
	textNormalBold(doc, "Permis", mxMid, mgY + spaceY * 2)
	textNormal(doc, client.permis, mxMid + spaceX * 1.5, mgY + spaceY * 2)
	textNormalBold(doc, "Date d'obtention", mxMid, mgY + spaceY * 3)
	textNormal(doc, client.datePermis, mxMid + spaceX * 1.5, mgY + spaceY * 3)
	textNormalBold(doc, "N° de permis", mxMid, mgY + spaceY * 4)
	textNormal(doc, client.numeroPermis, mxMid + spaceX * 1.5, mgY + spaceY * 4)

	//Entete right
	// textNormalBold(doc, 'Véhicule', mgXR, mgY)
	// textNormal(doc, entete.vehicule, mgXR + spaceX, mgY)
	// textNormalBold(doc, 'Plaques', mgXR, mgY + spaceY)
	// textNormal(doc, entete.plaques, mgXR + spaceX, mgY + spaceY)

	// doc.line(mx, mgY + spaceY * 5, width - mx, mgY + spaceY * 5)
}

export function drawLocationContrat(
	doc,
	location,
	vehiculeLocation,
	conducteurs,
	observations,
	moyenPaiements,
) {
	let my = 95,
		spaceX = 20,
		spaceY = 5,
		mgXR = width / 2 + Images.logo.width / 2,
		mxMid = width / 2 - spaceX - 2
	// ligne 1
	textTitle(doc, "Véhicule loué", mx, my)
	doc.line(mx, my + 1, mx + 22, my + 1)
	textNormalBold(doc, "Véhicule", mx, my + spaceY)
	textNormal(doc, vehiculeLocation.nom, mx + spaceX, my + spaceY, "left")
	textNormalBold(doc, "Plaques", mx, my + spaceY * 2)
	textNormal(
		doc,
		vehiculeLocation.plaques,
		mx + spaceX,
		my + spaceY * 2,
		"left",
	)
	textNormalBold(doc, "Kms", mx, my + spaceY * 3)
	textNormal(doc, "25000", mx + spaceX, my + spaceY * 3, "left")

	textTitle(doc, "Tarif", mxMid, my)
	doc.line(mxMid, my + 1, mxMid + 9, my + 1)
	textNormalBold(doc, "Nombre de jours", mxMid, my + spaceY)
	textNormal(
		doc,
		`${location.nbJours}`,
		mxMid + spaceX * 1.5,
		my + spaceY,
		"left",
	)
	textNormalBold(doc, "Tarif journalier", mxMid, my + spaceY * 2)
	textNormal(
		doc,
		`${location.tarifJourna} CHF`,
		mxMid + spaceX * 1.5,
		my + spaceY * 2,
		"left",
	)
	textNormalBold(doc, "Total", mxMid, my + spaceY * 3)
	textNormal(
		doc,
		`${Addons.round100(location.nbJours * location.tarifJourna)} CHF`,
		mxMid + spaceX * 1.5,
		my + spaceY * 3,
		"left",
	)
	textNormalBold(doc, "Caution", mxMid, my + spaceY * 4)
	textNormal(
		doc,
		`${location.caution} CHF`,
		mxMid + spaceX * 1.5,
		my + spaceY * 4,
		"left",
	)
	textNormalBold(doc, "Mode de paiement", mxMid, my + spaceY * 5)
	let mdp2 = moyenPaiements.find(
		(mdp) => mdp.id === location.cautionMoyenPaiement,
	)
	mdp2 ? (mdp2 = mdp2.nom) : (mdp2 = "")
	textNormal(doc, mdp2, mxMid + spaceX * 1.5, my + spaceY * 5, "left")

	textTitle(doc, "Location", mgXR, my)
	doc.line(mgXR, my + 1, mgXR + 15, my + 1)
	textNormalBold(doc, "Date du début", mgXR, my + spaceY)
	textNormal(
		doc,
		`${location.dateDebut} à ${location.heureDebut}`,
		mgXR + spaceX * 1.2,
		my + spaceY,
		"left",
	)
	textNormalBold(doc, "Retour prévu", mgXR, my + spaceY * 2)
	let datePrevue = moment(
		`${location.dateDebut} ${location.heureDebut}`,
		"DD-MM-YYYY kk:mm",
		true,
	)
		.add(parseInt(location.nbJours), "days")
		.format("DD-MM-YYYY à kk:mm")
	textNormal(doc, datePrevue, mgXR + spaceX * 1.2, my + spaceY * 2, "left")

	my += spaceY * 7
	// ligne 2
	textTitle(doc, "Dommages existants à la location", mx, my)
	doc.line(mx, my + 1, mx + 55, my + 1)
	textTitle(doc, "Conducteurs", mgXR, my)
	doc.line(mgXR, my + 1, mgXR + 22, my + 1)
	my += spaceY
	for (let i = 0; i < conducteurs.length; i++) {
		textNormal(
			doc,
			`${conducteurs[i].nom} ${conducteurs[i].prenom} ${conducteurs[i].isPrimary ? " (principal)" : ""}`,
			mgXR,
			my + spaceY * i,
		)
	}

	doc.addImage(
		Images.location.img,
		"PNG",
		mx,
		my,
		Images.location.width,
		Images.location.height,
	)
	doc.addImage(
		Images.fuel.img,
		"PNG",
		2 * mx + Images.location.width,
		my,
		Images.fuel.width,
		Images.fuel.height,
	)

	my += 40
	// ligne 3
	// if (observations.length > 0) {
	//     textTitle(doc, 'Observations', mx, my, 'left')
	//     doc.line(mx, my + 1, mx + 23, my + 1)
	//     my += spaceY
	//     for (let i = 0; i < observations.length; i++) {
	//         textNormal(doc, observations[i].label, mx, my, 'left')
	//         my += spaceY
	//     }
	//     my += 10
	// }
	// Debut loc
	my += 10
	textTitle(doc, "Début de la location", mx, my, "left")
	doc.line(mx, my + 1, mx + 35, my + 1)
	my += 5
	my += spaceY
	textNormalBold(doc, "Date", mx, my)
	textNormal(
		doc,
		`${location.dateDebut} à ${location.heureDebut}`,
		mx + 10,
		my,
		"left",
	)
	my += spaceY
	textNormalBold(
		doc,
		"Dégâts préexistants conformes au diagramme ci-dessus",
		mx,
		my,
	)
	my += spaceY
	//// signatures
	textNormalBold(doc, "Signature du locataire", width / 4, my, "center")
	textNormalBold(doc, "Signature du garage", (width * 3) / 4, my, "center")
	my += 2 * spaceY
	doc.line(width / 4 - 20, my, width / 4 + 20, my)
	doc.line((width * 3) / 4 - 20, my, (width * 3) / 4 + 20, my)
	my += 20
	// Fin loc
	textTitle(doc, "Fin de la location", mx, my, "left")
	doc.line(mx, my + 1, mx + 29, my + 1)
	my += 5
	my += spaceY
	textNormalBold(doc, "Véhicule retourné le", mx, my)
	textNormal(
		doc,
		`....../....../............ à ......h......`,
		mx + 30,
		my,
		"left",
	)
	my += spaceY
	textNormalBold(doc, "Suppléments", mx, my)
	my += spaceY
	textNormalBold(doc, "1.", mx + 5, my)
	textNormalBold(doc, "Jours de location", mx + 10, my)
	textNormalBold(
		doc,
		"Non          Oui         -   Prélevé sur caution : Non          Oui      ",
		mx + 50,
		my,
	)
	drawRect(doc, mx + 57, my - 3, 3, false)
	drawRect(doc, mx + 70, my - 3, 3, false)
	drawRect(doc, mx + 115, my - 3, 3, false)
	drawRect(doc, mx + 128, my - 3, 3, false)
	my += spaceY
	textNormalBold(doc, "2.", mx + 5, my)
	textNormalBold(doc, "Carburant", mx + 10, my)
	textNormalBold(
		doc,
		"Non          Oui         -   Prélevé sur caution : Non          Oui      ",
		mx + 50,
		my,
	)
	drawRect(doc, mx + 57, my - 3, 3, false)
	drawRect(doc, mx + 70, my - 3, 3, false)
	drawRect(doc, mx + 115, my - 3, 3, false)
	drawRect(doc, mx + 128, my - 3, 3, false)
	my += spaceY
	textNormalBold(doc, "3.", mx + 5, my)
	textNormalBold(doc, "Dégâts supplémentaires", mx + 10, my)
	textNormalBold(
		doc,
		"Non          Oui         -   Prélevé sur caution : Non          Oui      ",
		mx + 50,
		my,
	)
	drawRect(doc, mx + 57, my - 3, 3, false)
	drawRect(doc, mx + 70, my - 3, 3, false)
	drawRect(doc, mx + 115, my - 3, 3, false)
	drawRect(doc, mx + 128, my - 3, 3, false)
	my += spaceY
	//// signatures
	textNormalBold(doc, "Signature du locataire", width / 4, my, "center")
	textNormalBold(doc, "Signature du garage", (width * 3) / 4, my, "center")
	my += 2 * spaceY
	doc.line(width / 4 - 20, my, width / 4 + 20, my)
	doc.line((width * 3) / 4 - 20, my, (width * 3) / 4 + 20, my)
	// ligne 4
	textNormal(
		doc,
		"En signant le présent contrat, je déclare avoir lu et accepté les conditions générales de location.",
		width / 2,
		height - 10,
		"center",
	)
}
